import { hotRank } from "@/mocks/archive";

export default function HotRank() {
  return (
    <section id="hot" className="bg-background-50 border-t border-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          {/* 左说明 */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="flex items-center gap-2 text-sm font-medium text-accent-700">
                <i className="ri-fire-line" />
                热议 · 翻旧账榜
              </p>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                此刻正在被翻起的旧账
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                榜单按讨论量与存续热度滚动更新，仅反映当前公共关注，不代表价值判断。被扒与翻旧账的多为早年发言、旧切片与失效存档。
              </p>
              <div className="mt-5 rounded-lg border border-accent-200 bg-accent-100/60 p-4">
                <p className="flex items-start gap-2 text-sm text-accent-900">
                  <i className="ri-information-line mt-0.5" />
                  本榜为静态展示。每 30 分钟整理一次公开讨论热度，并不接入实时数据源。
                </p>
              </div>
            </div>
          </div>

          {/* 右列表（密排） */}
          <div className="lg:col-span-8">
            <ol className="divide-y divide-background-200 border-y border-background-200">
              {hotRank.map((item, i) => (
                <li key={item.id}>
                  <a
                    href="#deep"
                    className="group flex items-start gap-4 py-4 md:py-5 hover:bg-background-100 -mx-3 px-3 rounded-md transition-colors"
                  >
                    <span className="flex w-8 shrink-0 items-center justify-center">
                      <span
                        className={
                          "font-heading text-2xl font-bold " +
                          (i === 0
                            ? "text-accent-600"
                            : i === 1
                            ? "text-primary-600"
                            : "text-foreground-300")
                        }
                      >
                        {i + 1}
                      </span>
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900 whitespace-nowrap">
                          {item.kind}
                        </span>
                        <span className="text-xs text-foreground-400">{item.meta}</span>
                      </div>
                      <h3 className="mt-1 font-heading text-base md:text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700 transition-colors">
                        {item.title}
                      </h3>
                      <p className="mt-1.5 text-sm text-foreground-600 line-clamp-1 hidden sm:block">
                        {item.summary}
                      </p>
                    </div>
                    <i className="ri-arrow-right-up-line mt-1 text-foreground-300 group-hover:text-primary-600" />
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}